/* eslint-disable import/prefer-default-export */
import { unref } from 'vue';

/**
 * Get the value of value/ref/getter.
 */
export function toValue(r) {
  return typeof r === 'function'
    ? r()
    : unref(r);
}
